import { Box } from "@mui/material";
import { type FC, useEffect, useMemo, useState } from "react";
import { useColorScheme } from "web_myplann/Infrastructure/Themes/ColorSchemeProvider";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import {
	type SortKey,
	SortTypes,
} from "web_myplann/Portfolio/Components/SortDrawer";
import { PortfolioListPage } from "web_myplann/Portfolio/Pages/PortfolioListPage";
import { StyledCenteredStack } from "web_myplann/Shared/Components/StyledCenteredStack";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";
import { RowSkeletonLoader } from "web_myplann/Shared/RowSkeletonLoader";

export const StandalonePortfolioListWrapper: FC = () => {
	const { setMode } = useColorScheme();
	const { t } = useResource();
	const [activeSort] = useState<SortKey>(SortTypes.default);
	const [isLoading, setIsLoading] = useState(true);

	const contentBoxSx = useMemo(
		() => ({
			opacity: isLoading ? 0 : 1,
			transition: "opacity 0.2s",
			pt: "0 !important",
		}),
		[isLoading],
	);

	useEffect(() => {
		setMode({ paletteMode: "light" }, { persist: false });
	}, [setMode]);

	useEffect(() => {
		const style = document.createElement("style");
		style.textContent = `
			* {
				scrollbar-width: none !important;
				-ms-overflow-style: none !important;
			}
			*::-webkit-scrollbar {
				display: none !important;
			}
			[data-testid="portfolio-list-page"] {
				padding-top: 0 !important;
			}
		`;
		document.head.appendChild(style);
		return () => {
			document.head.removeChild(style);
		};
	}, []);

	return (
		<MyPlannLayout
			disableContentPadding
			disableBottomPadding
			topBar={
				<NavigationHeader title={t(Resources.Portfolio.Titles.portfolio)} />
			}
		>
			{isLoading && (
				<StyledCenteredStack spacing={2} px={5} zIndex={10}>
					<RowSkeletonLoader />
					<RowSkeletonLoader />
					<RowSkeletonLoader />
				</StyledCenteredStack>
			)}
			<Box sx={contentBoxSx}>
				<PortfolioListPage
					activeSort={activeSort}
					setIsLoading={setIsLoading}
				/>
			</Box>
		</MyPlannLayout>
	);
};
